<template>
  <modal
    size="small"
    :title="title"
    v-model="openModal"
  >
    <Form action="">

      <b-row>
        <b-col md="6" lg="6" sm="12">
          <Input
            label="Usuário (access_key)"
            id="accessKey"
            v-model="edit.accessKey"
            labelBold
            :maxlength="500"
            :description="errorValue('accessKey')"
            :error="!!errorValue('accessKey')"
          />
        </b-col>
        <b-col md="6" lg="6" sm="12">
          <Input
            label="Senha (secret_key)"
            id="secretKey"
            v-model="edit.secretKey"
            labelBold
            :maxlength="500"
            :description="errorValue('secretKey')"
            :error="!!errorValue('secretKey')"
          />
        </b-col>
      </b-row>

      <b-row>
        <b-col md="12" lg="12" sm="12">
          <Input
            label="Client ID Token"
            id="clientId"
            v-model="edit.clientId"
            labelBold
            :maxlength="500"
            :description="errorValue('clientId')"
            :error="!!errorValue('clientId')"
          />
        </b-col>
      </b-row>

      <ContainerButtons>
        <Button
          @click="handleSave"
          type="success"
          rounded
        >
          Salvar
        </Button>
      </ContainerButtons>
    </Form>
  </modal>
</template>

<script>
import { mapActions } from 'vuex';
import Modal from '../../../../components/Modal';
import {
  Form,
  Input,
  Button,
  ContainerButtons,
} from '../../../../components/Form';

export default {
  name: 'ModalShipay',
  components: {
    Button,
    Modal,
    Form,
    Input,
    ContainerButtons,
  },
  props: {
    data: {
      type: Object,
    },
    value: {
      type: Boolean,
      default: () => false,
      required: true,
    },
    save: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      openModal: this.open,
      edit: {},
      errors: {},
    };
  },
  watch: {
    value(newValue) {
      this.openModal = newValue;
    },
    data(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.edit = { ...newValue };
      }
    },
    openModal(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.$emit('input', newValue);
      }
    },
  },
  methods: {
    ...mapActions('application', ['setLoading']),
    async handleSave() {
      const { schema, validate } = this.$validate;
      const schemaConfiguration = schema.object().shape({
        accessKey: schema.string().required(),
        secretKey: schema.string().required(),
        clientId: schema.string().required(),
      });

      this.errors = {};
      const validations = await validate(schemaConfiguration, this.edit);
      if (!validations.status) {
        this.errors = validations.data;
        return;
      }

      this.save(this.edit);
    },
    errorValue(field) {
      return this.errors[field];
    },
  },
  computed: {
    title() {
      return this.data ? 'Editar configuração' : 'Nova configuração';
    },
  },
};
</script>
